import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
export const EVENT_NAME = 'outlink_web';
export const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_OUTLINK_FB_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_OUTLINK_FB_API_DOMAIN,
    databaseURL: process.env.NEXT_PUBLIC_OUTLINK_FB_DATABASE_URL,
    projectId: process.env.NEXT_PUBLIC_OUTLINK_FB_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_OUTLINK_FB_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_OUTLINK_FB_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_OUTLINK_FB_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_OUTLINK_FB_MEASUREMENT_ID,
};
const sendEvent = (analytics) => () => {
    logEvent(analytics, EVENT_NAME, { item_name: `외부링크_${window.location.href}` });
};
export const firebaseInit = () => {
    const send = sendEvent(getAnalytics(initializeApp(firebaseConfig)));
    const aList = document.getElementsByClassName('firebase-link');
    if (aList) {
        Array.from(aList).forEach((node) => node.addEventListener('click', send));
    }
};
